"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=legalDocumentVersion.js.map